import { supabase } from '@/lib/supabase';

export async function getCurrentSiteIdFromJwt(): Promise<string | null> {
  const { data: { session } } = await supabase.auth.getSession();
  const meta = session?.user?.user_metadata as any | undefined;
  return (meta?.site_id as string) ?? null;
}

/** Write site_id to user_metadata and refresh token so RLS sees it immediately. */
export async function setActiveSite(siteId: string) {
  const { error } = await supabase.auth.updateUser({ data: { site_id: siteId } });
  if (error) throw error;
  await supabase.auth.refreshSession();
}

/** Resolve site_id once from slug (cached locally), then setActiveSite */
export async function ensureActiveSiteFromSlug(slug: string) {
  const cacheKey = `site-id:${slug}`;
  const cached = localStorage.getItem(cacheKey);
  if (cached) {
    await setActiveSite(cached);
    return cached;
  }
  const { data, error } = await supabase
    .from('sites')
    .select('id')
    .eq('slug', slug)
    .maybeSingle();
  if (error) throw error;
  if (!data?.id) throw new Error(`Site not found for slug: ${slug}`);
  localStorage.setItem(cacheKey, data.id);
  await setActiveSite(data.id);
  return data.id as string;
}
